var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_vm._v("Carregando...")]):[(_vm.notFound)?_c('div',[_c('complete',{attrs:{"company":_vm.company}})],1):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }